import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getCompetitionIds } from '../../../modules/events/selectors';
import CompetitionConnect from './Competition';

const EXPANDED_COMPETITIONS = 3;

export class CompetitionList extends React.PureComponent {
  componentDidMount() {
    const { competitionIds, onAccordionChange } = this.props;

    competitionIds.slice(0, EXPANDED_COMPETITIONS).forEach(id => onAccordionChange(id, true));
  }

  render() {
    const { competitionIds, header, event, onAccordionChange } = this.props;
    return (
      <div className="competition-list">
        {competitionIds.size ? competitionIds.map((competitionId, index) => (
          <CompetitionConnect
            competitionId={competitionId}
            key={competitionId}
            defaultExpanded={index < EXPANDED_COMPETITIONS}
            header={header}
            event={event}
            onAccordionChange={onAccordionChange}
          />
        )) : (
          <div className="competition-list__empty-info">
            There are no events on this day.
          </div>
        )
        }
      </div>
    );
  }
}

CompetitionList.propTypes = {
  competitionIds: PropTypes.object.isRequired,
  header: PropTypes.func,
  event: PropTypes.func,
  onAccordionChange: PropTypes.func
};

CompetitionList.defaultProps = {
  header: () => undefined,
  event: eventId => (<div key={eventId}>{eventId}</div>),
  onAccordionChange: () => undefined
};

const mapStateToProps = state => ({
  competitionIds: getCompetitionIds(state)
});

export default connect(mapStateToProps)(CompetitionList);
